import {MenuStrategy} from "../MenuStrategy";

export class ScollegamentoUtenteMenuStrategy extends MenuStrategy {
   constructor() {
    super('Scollegamento Utente', '', '');
  }
}
